// Microsoft Clarity Integration

const initializeClarity = () => {
    window['clarity'] =
        window['clarity'] ||
        function(...args) {
            (window['clarity'].q = window['clarity'].q || []).push(args);
        };
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + 'mkhg0228ph';
    const y = document.getElementsByTagName('script')[0];
    y.parentNode?.insertBefore(t, y);
};

export default initializeClarity;
